import { useState } from 'react';
import AuthModal from './AuthModal';

export default function Hero() {
  const [showAuthModal, setShowAuthModal] = useState(false);

  return (
    <>
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/8f220eb1bba89f5bc1fd195b4066ea6a.jpg"
            alt="Mindshift AI Hero Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-teal-900/40 via-teal-800/30 to-teal-900/40"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
          <div className="inline-block bg-teal-500/20 backdrop-blur-sm text-white px-6 py-2 rounded-full text-sm font-semibold mb-8 border border-teal-300/30">
            <i className="ri-sparkling-2-line mr-2"></i>
            Dein KI-Coach für mentale Stärke und persönliches Wachstum
          </div>
          
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight">
            Entdecke dein volles Potenzial<br />
            <span className="text-teal-300">mit Mindshift AI</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-teal-50 mb-12 max-w-3xl mx-auto leading-relaxed">
            Dein persönlicher KI-Coach, der dir hilft, Klarheit zu finden, Ziele zu erreichen 
            und nachhaltig glücklicher zu werden – in nur 5 Minuten am Tag.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button
              onClick={() => setShowAuthModal(true)}
              className="bg-white text-teal-600 px-8 py-4 rounded-full hover:bg-gray-100 transition-all text-lg font-semibold shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-user-add-line mr-2"></i>
              Jetzt 7 Tage kostenlos testen
            </button>
            <a
              href="https://t.me/mindshift_ai_bot"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-teal-600/80 backdrop-blur-sm text-white px-8 py-4 rounded-full hover:bg-teal-700 transition-all text-lg font-semibold shadow-2xl hover:scale-105 border-2 border-white/30 whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              <i className="ri-telegram-line mr-2 text-xl"></i>
              Telegram Bot starten
            </a>
          </div>

          <p className="text-teal-100 text-sm">
            <i className="ri-shield-check-line mr-2"></i>
            Keine Kreditkarte erforderlich • 100% DSGVO-konform • In Deutschland gehostet
          </p>

          {/* Stats */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-white mb-2">5 Min</div>
              <div className="text-teal-100">Täglicher Zeitaufwand</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-white mb-2">8</div>
              <div className="text-teal-100">Lebensbereiche abgedeckt</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-white mb-2">24/7</div>
              <div className="text-teal-100">Verfügbar für dich</div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <div className="animate-bounce">
            <i className="ri-arrow-down-line text-3xl text-white"></i>
          </div>
        </div>
      </section>

      <AuthModal isOpen={showAuthModal} onClose={() => setShowAuthModal(false)} />
    </>
  );
}
